import { baselineNavigationQueryOptions } from '@/services/queryOptions/baselineNavigationQueryOptions';
import { useSuspenseQuery } from '@tanstack/react-query';
import BrandIconGreen from '../icons/brand-icon-green';
import React from 'react';
import { CustomNavLink } from '../custom-navlink';
import { onClickNavInternal } from '@/utils/navigation';
import { FOOTER_NAV_TYPE } from '@/constants/app.constants';

const BaselineNavigation = () => {
  const { data, isError } = useSuspenseQuery(baselineNavigationQueryOptions);
  if (isError) {
    return null;
  }
  const currentYear = new Date().getFullYear();
  return (
    <div className="container flex flex-col lg:flex-row lg:justify-between items-start md:items-center self-stretch gap-6 text-white text-xs lg:text-sm py-12 md:py-8 lg:py-10">
      <BrandIconGreen className="h-5 w-[93.55px] md:h-6 md:w-[112px]" />
      <p className="text-xs lg:text-sm">
        © Copyright {currentYear} Exetel Pty Ltd. All rights reserved.
      </p>
      <div className="flex gap-[5px] md:gap-[6px] lg:gap-[7px]">
        {data.map((item, index) => (
          <React.Fragment key={item.page.id}>
            {/* NOTE: Baseline Navigation doesn't support external URLs handling */}
            <CustomNavLink
              onClick={() =>
                onClickNavInternal({
                  url: item.page.url,
                  title: item.page.title,
                  navType: FOOTER_NAV_TYPE,
                })
              }
              to={item.page.url}
              search
            >
              {item.page.title}
            </CustomNavLink>
            {index < data.length - 1 && <span>|</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export { BaselineNavigation };
